import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { InputEl } from 'common/components/input';
import { ModalEl } from 'common/components/modal';
import { SpinnerEl } from 'common/components/spinner';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { BannerEl } from 'common/components/banner';
import { BannerTheme, BannerType } from 'common/components/banner/types';
import { CohortsLiteralBuilderEl } from 'common/widgets/cohorts-query-builder-new';
import { CreateEntityModalEl } from 'common/widgets/create-entity-modal';
/* eslint-disable sonarjs/cognitive-complexity */

export function template() {
  const {
    cohort,
    errors,
    loadingCohortCount,
    name,
    showCreateEntityModal
  } = this.state;

  const SaveCohortButton = _ref => {
    let {
      text,
      theme
    } = _ref;
    return jsx(ButtonEl, {
      sel: '.inline-cohorts-button.cohorts-save-button',
      attrs: {
        theme,
        elref: "saveButton"
      },
      on: {
        click: () => this.helpers.saveStagedCohortOnInlineModal()
      }
    }, text);
  };

  const ApplyCohortButton = _ref2 => {
    let {
      text
    } = _ref2;
    return jsx(ButtonEl, {
      sel: '.inline-cohorts-button.cohorts-apply-button',
      attrs: {
        theme: ButtonTheme.Primary
      },
      on: {
        click: this.helpers.commitCohort
      }
    }, text);
  };

  return jsx("div", {
    sel: '.inline-cohorts-modal'
  }, this.helpers.isOpen() && showCreateEntityModal ? jsx(CreateEntityModalEl, {
    attrs: this.helpers.buildCreateEntityModalAttrs(),
    on: {
      cancel: this.helpers.closeEntityModal,
      save: this.helpers.saveStagedCohortOnCreateModal,
      saveAndShare: this.helpers.saveStagedCohortOnCreateModal
    },
    props: {
      existingEntityNames: this.helpers.getCohortNames()
    }
  }) : jsx(ModalEl, {
    sel: '.inline-cohorts-modal',
    attrs: this.helpers.getModalAttributes(),
    on: {
      change: this.helpers.handleModalStateChange
    }
  }, jsx("section", {
    sel: '.inline-cohorts-modal-scroll-wrapper'
  }, jsx("section", {
    sel: '.inline-cohorts-modal-header'
  }, jsx("div", {
    sel: '.modal-title.mp-font-size-xxl.mp-font-weight-bold'
  }, this.helpers.getTitle()), this.state.cohort.id && jsx("div", {
    sel: '.modal-subtitle.mp-font-size-small'
  }, "Cohort ID: ", this.state.cohort.id)), jsx("section", {
    sel: '.inline-cohorts-workspace'
  }, jsx("section", {
    sel: '.inline-cohorts-builder'
  }, this.helpers.isOpen() ? jsx(null, null, !this.helpers.isNewSavedCohort() && !this.attr("can-edit") ? jsx("div", {
    sel: '.inline-cohorts-edit-banner'
  }, jsx(BannerEl, {
    attrs: {
      theme: BannerTheme.Info,
      type: BannerType.Embedded,
      'body-text': this.helpers.getBannerText(),
      elref: "permissionBanner"
    },
    style: {
      'text-transform': "initial"
    }
  })) : jsx("section", {
    sel: '.inline-cohorts-name-input'
  }, jsx(InputEl, {
    attrs: {
      placeholder: "Cohort name",
      maxlength: 190,
      'validation-status': errors.size > 0 ? "invalid" : "",
      'error-message': this.helpers.getCohortNameError()
    },
    props: {
      value: name
    },
    on: {
      input: this.helpers.handleNameInputChange
    }
  })), jsx("section", {
    sel: '.inline-cohorts-builder-qb-wrapper'
  }, !this.helpers.isReportBasedCohort() ? jsx(CohortsLiteralBuilderEl, {
    on: {
      cohortUpdated: this.helpers.handleCohortUpdated,
      track: this.helpers.trackCohortsBuilderEvent
    },
    attrs: {
      'track-name': this.attr("track-name"),
      cohort: cohort.serialize(),
      'project-id': this.attr("project-id"),
      'workspace-id': this.attr("workspace-id"),
      'show-cohort-count': this.attr("show-cohort-count"),
      'project-has-cohorts': this.attr("project-has-cohorts"),
      'support-b2b-cohorts': this.attr("support-b2b-cohorts"),
      'data-group-id': this.attr("data-group-id"),
      'user-id': this.attr("user-id"),
      'non-collapsible': true,
      'hide-edit-controls': true,
      elref: "cohortBuilder"
    },
    props: {
      context: this.helpers.getMPContext()
    }
  }) : jsx("div", {
    sel: '.no-cohort-definition'
  }, jsx("div", {
    sel: '.cohort-not-editable-text'
  }, "Cohort definitions created from reports cannot be edited"), jsx("div", {
    sel: '.cohort-vew-link-button'
  }, jsx(ButtonEl, {
    attrs: {
      icon: "share",
      elref: "viewUsersButton"
    },
    on: {
      click: this.helpers.openCohortViewUser
    }
  }, "View Cohort Users"))))) : null, jsx("div", {
    sel: '.inline-cohorts-builder-footer'
  }, jsx("div", {
    sel: '.left-controls'
  }, this.attr("show-cohort-count") ? jsx("div", {
    sel: '.cohort-count'
  }, loadingCohortCount ? jsx(SpinnerEl, null) : jsx("div", {
    sel: '.count-number'
  }, this.helpers.displayCohortCount())) : null, this.attr("can-save") ? this.helpers.isSavingRestricted() ? jsx("div", {
    sel: '.upsell-button'
  }, jsx(TooltipEl, {
    attrs: {
      placement: Placement.Right
    }
  }, "When you upgrade your plan, cohorts can be created and saved to use across all reports in a project."), jsx(ButtonEl, {
    attrs: {
      icon: "share"
    },
    on: {
      click: this.helpers.openPricingUpsell
    }
  }, "Upgrade to Save")) : null : null), jsx("div", {
    sel: '.right-controls'
  }, this.attr("can-apply-unsaved-cohort") && this.attr("can-save") ? jsx(SaveCohortButton, {
    text: "".concat(this.helpers.isNewUnsavedCohort() ? "Create" : "Edit", " & Save Cohort"),
    theme: ButtonTheme.Secondary
  }) : null, this.attr("can-apply-unsaved-cohort") ? jsx(ApplyCohortButton, {
    text: "".concat(this.helpers.isNewUnsavedCohort() ? "Create" : "Edit", " Cohort")
  }) : jsx(null, null, !this.helpers.isNewSavedCohort() && !this.attr("can-edit") ? !this.helpers.isReportBasedCohort() ? jsx(ButtonEl, {
    sel: '.cohorts-save-button',
    attrs: {
      theme: ButtonTheme.Secondary,
      elref: "saveButton",
      'not-focusable': true
    },
    on: {
      click: () => this.helpers.saveStagedCohortOnInlineModal(true)
    }
  }, "Save as New") : null : jsx(SaveCohortButton, {
    text: this.helpers.isNewCohort() ? "Create Cohort" : "Save",
    theme: ButtonTheme.Primary
  })))))))));
}